export default __webpack_public_path__ + "static/media/mode-57.c7fd3415.svg";